/* eslint-disable no-useless-escape */
// 字符串复制
import { Decimal } from 'decimal.js';
import moment from 'moment'

function repeat(target, n) {
  var s = '';
  while (n > 0) {
    if (n % 2 === 1) {
      s += target;
    }
    if (n === 1) {
      break;
    }
    target += target;
    n = n >> 1;
  }
  return s;
}

function singleFormat(str) {
  return str.toString().length === 1 ? '0' + str : str;
}

function getYMD(time) {
  let year = time.getFullYear();
  let month = time.getMonth() + 1;
  let date = time.getDate();
  return year + '-' + singleFormat(month) + '-' + singleFormat(date);
}

function getHMS(time) {
  let hours = time.getHours();
  let minutes = time.getMinutes();
  let seconds = time.getSeconds();
  return singleFormat(hours) + ':' + singleFormat(minutes) + ':' + singleFormat(seconds);
}
function getTimeZone(time) {
  let GTM_8 = 480; // -480
  let date = new Date(time);
  let subMin = date.getTimezoneOffset() + GTM_8;
  date.setMinutes(date.getMinutes() + subMin);
  return date;
}

class Precision {
  // 乘法
  times(num1, num2, ...others) {
    if (others.length > 0) {
      return this.times(this.times(num1, num2), ...others);
    }
    num1 = num1 || 0;
    num2 = num2 || 0;
    const num1Changed = this.float2Fixed(num1);
    const num2Changed = this.float2Fixed(num2);
    // 把两个数的小数位数相加
    const baseNum = this.digitLength(num1) + this.digitLength(num2);
    const leftValue = num1Changed * num2Changed;
    // this.checkBoundary(leftValue)
    return leftValue / Math.pow(10, baseNum);
  }
  // 精确加法
  plus(num1, num2, ...others) {
    if (others.length > 0) {
      return this.plus(this.plus(num1, num2), ...others);
    }
    const baseNum = Math.pow(10, Math.max(this.digitLength(num1), this.digitLength(num2)));
    return (this.times(num1, baseNum) + this.times(num2, baseNum)) / baseNum;
  }
  // 精确减法
  minus(num1, num2, ...others) {
    if (others.length > 0) {
      return this.minus(this.minus(num1, num2), ...others);
    }
    const baseNum = Math.pow(10, Math.max(this.digitLength(num1), this.digitLength(num2)));
    return (this.times(num1, baseNum) - this.times(num2, baseNum)) / baseNum;
  }
  // 精确除法
  divide(num1, num2, ...others) {
    if (others.length > 0) {
      return this.divide(this.divide(num1, num2), ...others);
    }
    const num1Change = this.float2Fixed(num1);
    const num2Change = this.float2Fixed(num2);
    return this.times(
      num1Change / num2Change,
      Math.pow(10, this.digitLength(num2) - this.digitLength(num1)),
    );
  }
  // 四舍五入，且保留小数
  round(num, ratio) {
    const base = Math.pow(10, ratio);
    return this.divide(Math.round(this.times(num, base)), base);
  }
  // 向下取整，且保留小数
  floorRound(num, ratio) {
    return num;
  }
  // 把小数转成整数，支持科学计数法。如果是小数则放大成整数
  float2Fixed(num) {
    if (!~num.toString().indexOf('e')) {
      return Number(num.toString().replace('.', ''));
    }
    const dlen = this.digitLength(num);
    return dlen > 0 ? num * Math.pow(10, dlen) : num;
  }
  // 获取当前数小数位的长度(处理科学计数法，本质上处理e-n的情况)
  digitLength(num) {
    const eSplit = num.toString().split(/[eE]/);
    const len = (eSplit[0].split('.')[1] || '').length - (+eSplit[1] || 0);
    return len > 0 ? len : 0;
  }
  //  检测数字是否越界，如果越界给出提示
  checkBoundary(num) {
    if (num > Number.MAX_SAFE_INTEGER || num < Number.MIN_SAFE_INTEGER) {
      console.log(
        `${num} is beyond boundary when transfer to integer, the results may not be accurate`,
      );
    }
  }
}

const Utils = {
  precision: new Precision(),

  // Decimal.add(x,y); 加法
  // Decimal.sub(x, y); 减法
  // Decimal.div(x, y); 除法
  // Decimal.mul(x, y); 乘法
  decimal: Decimal,
  //截取小数位
  toFixedJQ(num, digits) {
    if (isNaN(Number(num))) {
      return num;
    }
    return new Decimal(num).toFixed(digits, Decimal.ROUND_DOWN);
  },
  // 获取小数位数
  retainDecimals(value, obj = {}) {
    if (!value) return 0;
    value = value.toString();
    if (~value.indexOf('e')) {
      return 0;
    }
    let decimals = '';
    if (value.indexOf('.') > 0 && obj.decimal !== 0) {
      let decimalsRe = new RegExp('[.]{1}[0-9]{0,' + (obj.decimal || 8) + '}');
      let decimalsExec = decimalsRe.exec(value);
      decimalsExec && (decimals = decimalsExec[0]);
    }
    let v = 0;
    let re = new RegExp('^-?[0-9]{1}[0-9]{0,' + (obj.integer - 1 || 8) + '}');
    v = re.exec(value);
    let n = '';
    if (v) {
      n = v[0];
    }
    return n + decimals;
  },
  // 数字加逗号
  numberFormat(num) {
    if (num) {
      let [num1, num2] = num.toString().split('.');
      num1 = num1
        .split('')
        .reverse()
        .map((item, index) => {
          return index % 3 || !index || item === '-' || item === '+' ? item : item + ',';
        })
        .reverse()
        .join('');
      num2 ? (num = num1 + '.' + num2) : (num = num1);
    }
    return num;
  },
  // 补充0
  splitFormat(num, fractionDigits, len) {
    if (isNaN(num)) return num;
    if (num) {
      if (num === '0') {
        return num;
      }
      let digit = num.toString().split('.');
      if (fractionDigits === 0) {
        return digit[0];
      }
      if (digit.length > 1) {
        if (fractionDigits === 0) {
          return digit[0];
        } else if (digit[1].length < fractionDigits) {
          let digitResult = '';
          for (let i = 0; i < fractionDigits - digit[1].length; i++) {
            digitResult += '0';
          }
          return num + digitResult;
        } else {
          let digitResult = digit[1].substring(0, len || fractionDigits);
          return digit[0] + '.' + digitResult;
        }
      } else {
        let digitResult = '.';
        for (let i = 0; i < fractionDigits; i++) {
          digitResult += '0';
        }
        return num + digitResult;
      }
    } else {
      return num;
    }
  },
  // 位数不够补0
  addZero(num, len) {
    if (isNaN(num)) return 0;
    let str = String(num);
    return String(str).replace(new RegExp(`^(\\-?)(\\d+)(\\.\\d{1,${len}})?`), (n, a, b, c) => {
      let str = a + b; // .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      if (!len) {
        return str;
      }
      if (c) {
        str += c + repeat('0', len - c.length);
      } else {
        str += '.' + repeat('0', len);
      }
      return str;
    });
  },
  // 数字加逗号
  addCommom(num, len) {
    if (isNaN(num) || !num) return num;
    num = String(num);
    if (!isNaN(len)) {
      if (len === 0) {
        num = num.split('.')[0];
      }
      return num.replace(/(\d+)(\.\d+)?/, (a, b, c) => {
        return b.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + (c ? c.slice(0, len + 1) : '');
      });
    } else {
      return num.replace(/^\d+/, a => {
        return a.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      });
    }
  },
  // 获取时间年月日 时分秒
  timeFormat(time, type, isZone = false) {
    let date = null;
    if (isZone) {
      date = getTimeZone(time);
    } else {
      date = new Date(time);
    }
    // if (!type) return getYMD(date) + ' ' + getHMS(date);
    if (!type) return moment(getYMD(date) + ' ' + getHMS(date)).utcOffset(8).format('YYYY-MM-DD HH:mm:ss');
    switch (type) {
      case 'HMS':
        return getHMS(date);
      case 'YMD':
        return getYMD(date);
    }
  },
  //毫秒转换HMS
  timeFormatHMS(time) {
    let hours = parseInt(time / (1000 * 60 * 60));
    let _minutes = time - hours * 1000 * 60 * 60;
    let minutes = parseInt(_minutes / (1000 * 60));
    let _seconds = _minutes - minutes * 1000 * 60;
    let seconds = parseInt(_seconds / 1000);
    return singleFormat(hours) + ':' + singleFormat(minutes) + ':' + singleFormat(seconds);
  },
  //毫秒转换01:10'30"
  timeFormatH(time) {
    let hours = parseInt(Decimal.div(time, 60 * 60));
    let m = parseInt(Decimal.div(time - hours * 60 * 60, 60));
    let s = time - hours * 60 * 60 - m * 60;
    hours = hours > 0 ? (hours < 10 ? '0' + hours : hours) + ':' : '';
    m = m > 0 ? (m < 10 ? '0' + m : m) + "'" : '';
    s = s > 0 ? s + '"' : 0;
    return hours + m + s;
  },
  cssProperty(attr) {
    var prefix = ['O', 'ms', 'Moz', 'Webkit'];
    var len = prefix.length;
    var style = document.createElement('i').style;
    if (attr in style) {
      return true;
    }
    attr = attr.replace(/^[a-z]/, function (val) {
      return val.toUpperCase();
    });
    while (len--) {
      if (prefix[len] + attr in style) {
        return true;
      }
    }
    return false;
  },

  find(list, f) {
    return list.filter(f)[0];
  },

  deepCopy(obj, cache = []) {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    const hit = find(cache, c => c.original === obj);
    if (hit) {
      return hit.copy;
    }

    const copy = Array.isArray(obj) ? [] : {};
    cache.push({
      original: obj,
      copy,
    });
    Object.keys(obj).forEach(key => {
      copy[key] = this.deepCopy(obj[key], cache);
    });
    return copy;
  },

  forEachValue(obj, fn) {
    Object.keys(obj).forEach(key => fn(obj[key], key));
  },

  isObject(obj) {
    return obj !== null && typeof obj === 'object';
  },

  isPromise(val) {
    return val && typeof val.then === 'function';
  },

  assert(condition, msg) {
    if (!condition) throw new Error(`[vuex] ${msg}`);
  },

  partial(fn, arg) {
    return function () {
      return fn(arg);
    };
  },

  //获取浏览器参数值
  getQueryVariable(variable) {
    let whi = window.location.href.indexOf('?');
    let query = window.location.href.substring(whi + 1);
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (pair[0] == variable) {
        console.log(variable, ':', pair[1]);
        return pair[1];
      }
    }
    return false;
  },

  //电话或者邮箱加密
  getPhoneOrEmail(v) {
    if (v.indexOf('@') > -1) {
      //邮箱
      let p = v.split('@');
      let xnum = 0;
      let centerstr = '';
      if (p[0].length > 4) {
        //大于4位隐藏@符号前4位
        xnum = p[0].length - 4;
        p[0] = p[0].substring(0, p[0].length - 4);
      } else {
        //只有一位显示*，大于1位第一位展示，后面是*
        xnum = p[0].length - 1;
        if (p[0].length == 1) {
          p[0] = '*';
        } else {
          p[0] = p[0].substring(0, 1);
        }
      }
      for (let i = 0; i < xnum; i++) {
        centerstr += '*';
      }
      centerstr += '@';
      if (p[1]) {
        return p[0] + centerstr + p[1];
      } else {
        return p[0] + centerstr;
      }
    } else if (v.length > 0) {
      //手机
      let l = v.length;
      let lf = parseInt(l / 2) - 2;
      let lr = parseInt(l / 2) + 2;
      lf = lf <= 0 ? 1 : lf;
      lr = lr >= l ? l - 1 : lr;
      let lfstr = v.substring(0, lf);
      let lrstr = v.substring(lr, l);
      let xnum = l - lfstr.length - lrstr.length;
      let centerstr = '';
      for (let i = 0; i < xnum; i++) {
        centerstr += '*';
      }
      if (centerstr == '') {
        if (l == 2) return lfstr + '*';
        else return '*';
      } else {
        return lfstr + centerstr + lrstr;
      }
    } else {
      return v;
    }
  },
  // 检测邮箱格式
  checkEmail(email) {
    let filter =
      /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(email.trim())) {
      return false;
    } else {
      return true;
    }
  },
  checkMobile(mobile) {
    let filter = /^\d{6,}$/;
    if (!filter.test(mobile.trim())) {
      return false;
    } else {
      return true;
    }
  },
  //计算开仓方向
  callDic(v) {
    let _dic = '',
      _red = false,
      _green = false,
      _dici = 0;
    // status:  open-开仓 close-平仓 cancel-撤单
    // direction: long-多 short-空
    // positionModel 0 逐仓 1全仓
    // originalType:  execute-市价  plan-限价委托  planTrigger-计划委托

    // 开多的话绿色，平多应该是红色，开空是红色，平空应该是绿色
    let _this = window.vm;
    if (v.positionModel == 0) {
      //逐仓
      if (v.direction == 'long') {
        //做多
        if (v.status == 'close') {
          //平仓
          _dic = _this.$t('tableList.逐仓平多');
          _dici = 3;
          _red = true;
        } else {
          //开仓
          _dic = _this.$t('tableList.逐仓开多');
          _dici = 1;
          _green = true;
        }
      } else {
        //做空
        if (v.status == 'close') {
          _dic = _this.$t('tableList.逐仓平空');
          _dici = 4;
          _green = true;
        } else {
          _dic = _this.$t('tableList.逐仓开空');
          _dici = 2;
          _red = true;
        }
      }
    } else {
      //全仓
      if (v.direction == 'long') {
        //做多
        if (v.status == 'close') {
          //平仓
          _dic = _this.$t('tableList.全仓平多');
          _dici = 7;
          _red = true;
        } else {
          //开仓
          _dic = _this.$t('tableList.全仓开多');
          _dici = 5;
          _green = true;
        }
      } else {
        //做空
        if (v.status == 'close') {
          //平仓
          _dic = _this.$t('tableList.全仓平空');
          _dici = 8;
          _green = true;
        } else {
          //开仓
          _dic = _this.$t('tableList.全仓开空');
          _dici = 6;
          _red = true;
        }
      }
    }
    return { dic: _dic, red: _red, green: _green, dici: _dici };
  },
  //计算全仓风险率
  /**
   *
   * @param {*} available 总可用
   * @param {*} list 仓位列表
   * @returns 风险率
   */
  callAllRate(available, list) {
    let allyk = this.callAllFDYK(list); //带手续费
    let rate = '-';
    //风险率：全仓风险度（风险率）：=(账户余额 + SUM(浮动盈亏-手续费-过夜费))/已用保证金求和
    try {
      if (allyk != '-') {
        //减去手续费
        allyk = this.decimal.sub(allyk, this.callAllFee(list));
        let allMargin = this.callAllMargin(list);
        if (allMargin == 0) {
          rate = '-';
        } else {
          rate = this.decimal.div(this.decimal.add(available, allyk), allMargin);
        }
      } else {
        rate = '-';
      }
    } catch (error) {
      console.error(error);
    }
    return rate;
  },

  //计算逐仓保证金率
  callBzjRate(v, _symbol) {
    let _this = window.vm;
    //       逐仓：保证金率 =（固定保证金+未实现盈亏）／仓位价值，
    let _margin = v.margin;
    let _yingkui = this.callFDYK(v, _symbol);
    let _jiazhi = this.callJiaZhi(v, _symbol);
    try {
      return this.decimal.div(this.decimal.add(_margin, _yingkui), _jiazhi);
    } catch (error) {
      return '-';
    }
  },

  //计算全仓保证金率
  callAllBzjRate(available, list, totalFreezeMarginMultiplyLeverage) {
    //       逐仓：保证金率 =（固定保证金+未实现盈亏）／仓位价值，
    // 全仓：保证金率 =（Available + 浮动盈亏 - TotalFee - TotalFundingFee）／（仓位价值+挂单冻结保证金*杠杆倍数）
    let allyk = this.callAllFDYK(list); //带手续费
    let bzjrate = '-';
    //全仓 计算全仓保证金率
    try {
      if (allyk != '-') {
        //减去手续费
        allyk = this.decimal.sub(allyk, this.callAllFee(list));
        let allMargin = this.callAllMargin(list);

        let totalJiaZhi = this.callAllJiaZhi(list);
        bzjrate = this.decimal.div(
          this.decimal.add(available, allyk),
          this.decimal.add(totalJiaZhi, totalFreezeMarginMultiplyLeverage),
        );
      } else {
        bzjrate = '-';
      }
    } catch (error) {
      // console.log('计算全仓风险率报错');
      console.error(error);
    }
    return bzjrate;
  },
  //计算总仓位价值
  callAllJiaZhi(list) {
    let total_jiazhi = 0;
    list.map(vv => {
      if (vv.mode == 2) {
        //体验金仓位 不参与总浮动盈亏计算
      } else {
        let v = vv.v || vv;
        let _symbol = window.vm.$store.getters['getCodeDataByBase'](
          v.instrument.toLowerCase(),
        );
        let _jiazhi = this.callJiaZhi(v, _symbol);
        //仓位价值
        if (_jiazhi == '-') {
          return 0;
        } else {
          total_jiazhi = this.decimal.add(total_jiazhi, _jiazhi);
        }
      }
    });
    return total_jiazhi;
  },
  callJiaZhi(v, _symbol) {
    //标记价格
    let _priceSign = (_symbol && Number(_symbol.priceSign)) || 1;
    //baseSize = 面值X张数
    //仓位价值 = 面值X张数X标记价格
    let jiazhi = this.decimal.mul(v.baseSize, _priceSign);
    return Number(jiazhi);
  },

  //计算总保证金
  /**
   *
   * @param {*} list 仓位列表
   * @returns 总保证金
   */
  callAllMargin(list) {
    let allmargin = 0;
    list.map(vv => {
      if (vv.mode == 2) {
        //体验金仓位 不参与总手续费计算
      } else {
        let v = vv.v || vv;
        allmargin = this.decimal.add(allmargin, v.margin);
      }
    });
    return allmargin;
  },
  //计算总手续费
  /**
   *
   * @param {*} list 仓位列表
   * @returns 总手续费
   */
  callAllFee(list) {
    let allfee = 0;
    list.map(vv => {
      if (vv.mode == 2) {
        //体验金仓位 不参与总手续费计算
      } else {
        let v = vv.v || vv;
        allfee = this.decimal.add(allfee, v.fee);
      }
    });
    return allfee;
  },
  //计算总浮动盈亏
  callAllFDYK(list) {
    let _this = window.vm;
    let total_floating_win_kui = 0;
    list.map(vv => {
      if (vv.mode == 2) {
        //体验金仓位 不参与总浮动盈亏计算
      } else {
        let v = vv.v || vv;
        let _symbol = _this.$store.getters['swaps/getCodeDataByBase'](v.instrument.toLowerCase());
        let _floating_win_kui = this.callFDYK(v, _symbol);
        //浮动盈亏
        if (_floating_win_kui == '-') {
          return 0; //没有标记价格 无法计算单个持仓浮动盈亏 总浮动盈亏返回0
        } else {
          total_floating_win_kui = this.decimal.add(total_floating_win_kui, _floating_win_kui);
        }
      }
    });
    return total_floating_win_kui;
  },
  //计算浮动盈亏
  callFDYK(v, _symbol) {
    // 浮动盈亏
    let _floating_win_kui = '-';
    try {
      if (_symbol && Number(_symbol.priceSign)) {
        let _oneLotSize = (_symbol && _symbol.data.oneLotSize) || 1;
        if (v.direction == 'long') {
          //（最新标记价格-开仓价格）*张数*面值
          _floating_win_kui = this.decimal.mul(
            this.decimal.sub(_symbol.priceSign, v.openPrice),
            this.decimal.mul(v.currentPiece, _oneLotSize),
          );
        } else {
          //（开仓价格-最新标记价格）*张数*面值
          _floating_win_kui = this.decimal.mul(
            this.decimal.sub(v.openPrice, _symbol.priceSign),
            this.decimal.mul(v.currentPiece, _oneLotSize),
          );
        }
      } else {
        _floating_win_kui = '-';
      }
    } catch (error) {
      // console.log('计算浮动盈亏报错');
      console.error(error);
    }
    return _floating_win_kui;
  },
  //预估止盈止损
  callZyZs(v) {
    //预估止盈止损价
    let _stopZy = '-',
      _stopZs = '-';
    try {
      if (v.direction == 'long') {
        //多
        if (Number(v.stopProfitPrice)) {
          _stopZy = Number(v.stopProfitPrice); //优先使用具体价格
        } else if (Number(v.stopProfitRate)) {
          //做多平仓价=开仓价（1+止盈比例/杠杆倍数）
          _stopZy = this.decimal.mul(
            v.openPrice,
            this.decimal.add(1, this.decimal.div(v.stopProfitRate, v.leverage)),
          );
        } else {
          _stopZy = '-';
        }
        if (Number(v.stopLossPrice)) {
          _stopZs = Number(v.stopLossPrice); //优先使用具体价格
        } else if (Number(v.stopLossRate)) {
          //通过比例计算
          //做多平仓价=开仓价（1-止盈比例/杠杆倍数）
          _stopZs = this.decimal.mul(
            v.openPrice,
            this.decimal.sub(1, this.decimal.div(v.stopLossRate, v.leverage)),
          );
        } else {
          _stopZs = '-';
        }
      } else {
        //空
        if (Number(v.stopProfitPrice)) {
          _stopZy = Number(v.stopProfitPrice); //优先使用具体价格
        } else if (Number(v.stopProfitRate)) {
          //通过比例计算
          //做空平仓价=开仓价（1-止盈比例/杠杆倍数）
          _stopZy = this.decimal.mul(
            v.openPrice,
            this.decimal.sub(1, this.decimal.div(v.stopProfitRate, v.leverage)),
          );
        } else {
          _stopZy = '-';
        }

        if (Number(v.stopLossPrice)) {
          _stopZs = Number(v.stopLossPrice); //优先使用具体价格
        } else if (Number(v.stopLossRate)) {
          //通过比例计算
          _stopZs = this.decimal.mul(
            v.openPrice,
            this.decimal.add(1, this.decimal.div(v.stopLossRate, v.leverage)),
          );
          //做空平仓价=开仓价（1+止损比例/杠杆倍数）
          _stopZs = v.openPrice * (1 + v.stopLossRate / v.leverage);
        } else {
          _stopZs = '-';
        }
      }
    } catch (error) {
      // console.log('计算预估止盈止损价报错');
      console.error(error);
    }
    return { stopZy: _stopZy, stopZs: _stopZs };
  },
  //合并仓位计算开仓均价
  callOpenJunJia(list) {
    let junjia = {},
      key = '';
    for (let i = 0; i < list.length; i++) {
      key = list[i].instrument + list[i].direction;
      if (!junjia[key]) {
        junjia[key] = {
          price: 0, //均价
          piece: 0, //张数
          margin: 0, //保证金
          data: [],
        };
      }
      junjia[key].data.push(list[i]);
    }

    for (let key in junjia) {
      // console.log(key, junjia[key]);
      junjia[key].data.map(v => {
        junjia[key].price = this.decimal.add(junjia[key].price, v.openPrice);
        junjia[key].piece = this.decimal.add(junjia[key].piece, v.currentPiece);
        junjia[key].margin = this.decimal.add(junjia[key].margin, v.margin);
      });
      junjia[key].piece = Number(junjia[key].piece);
      junjia[key].margin = Number(junjia[key].margin);
      junjia[key].price = Number(this.decimal.div(junjia[key].price, junjia[key].data.length));
    }
    return junjia;
  },
  //计算预估强评价
  callStrongPrice(v, _symbol, junjia, available, allyk, totalMargin) {
    allyk = Number(allyk);
    totalMargin = Number(totalMargin);
    try {
      //面值
      let _oneLotSize = (_symbol && _symbol.data.oneLotSize) || 1;
      //标记价格
      let _priceSign = (_symbol && Number(_symbol.priceSign)) || 1;
      //维持保证金率
      let _stopSurplusRate = (_symbol && _symbol.data.stopSurplusRate) || 1;
      //强平风险率
      let _stopCrossPositionRate = (_symbol && _symbol.data.stopCrossPositionRate) || 1;
      //开仓价
      let _openPrice = v.openPrice;
      //张数
      let _piece = v.currentPiece;
      //杠杆倍数
      let _leverage = v.leverage;
      //保证金
      let _margin = v.margin;
      //模式
      let _positionModel = v.positionModel;
      //方向
      let _dic = v.direction == 'long' ? 1 : -1;
      //总可用
      let _available = available;
      if (_positionModel == 0) {
        /*
      逐仓:

      最大亏损 = 维持保证金率 * (合约面值 * 合约张数 * 开仓价格 / 杠杆倍数）- 持仓保证金
      强平价 = 持仓均价 + 开仓方向(多1、空-1) * (最大亏损 / (张数 * 合约面值))

      */
        let one = this.decimal.div(
          this.decimal.mul(this.decimal.mul(_oneLotSize, _piece), _openPrice),
          _leverage,
        );
        let two = this.decimal.sub(this.decimal.mul(_stopSurplusRate, one), _margin);
        let three = this.decimal.add(
          _openPrice,
          this.decimal.mul(_dic, this.decimal.div(two, this.decimal.mul(_oneLotSize, _piece))),
        );
        return three;
      } else {
        /*
        全仓:

        第一步先合并仓位，同币种同方向合并仓位，在计算:

        公式1, 适用于有对冲单，且可以完全对冲: 两单都显示 "--"

        公式2, 适用于有对冲单，单不能完全对冲: 方向以大仓位为准
                强平价 = 标记价 - 开仓方向(多1、空-1) * (available(接口字段) + sum(所有仓位浮动盈亏) - sum(手续费) - sum(仓位保证金) * 风险率) / (abs(张数之差) * 合约面值)

        公式3, 适用于其他情况:
                强平价 = 标记价 - 开仓方向(多1、空-1) * (available(接口字段) + sum(所有仓位浮动盈亏) - sum(手续费) - sum(仓位保证金) * 风险率) / (张数 * 合约面值)

        最终处理: <= 0 或者 >= 标记价 * 10， 显示 "--"


        */
        //判断是否可以完全对冲
        let key1 = v.instrument + 'long',
          key2 = v.instrument + 'short';
        if (junjia[key1] && junjia[key2] && junjia[key1].piece == junjia[key2].piece) {
          // 适用于有对冲单，且可以完全对冲: 两单都显示 "--"
          return '--';
        } else if (junjia[key1] && junjia[key2] && junjia[key1].piece != junjia[key2].piece) {
          _dic = junjia[key1].piece > junjia[key2].piece ? 1 : -1;
          if (allyk == '-') {
            return '--';
          }
          // debugger;
          // 强平价 = 标记价 - 开仓方向(多1、空-1) * (available(接口字段) + sum(所有仓位浮动盈亏) - sum(手续费) - sum(仓位保证金) * 风险率) / (abs(张数之差) * 合约面值)
          let one = this.decimal.sub(
            this.decimal.add(_available, allyk),
            this.decimal.mul(totalMargin, _stopCrossPositionRate),
          );
          // console.log('one', Number(one));
          let two = this.decimal.div(
            this.decimal.mul(_dic, one),
            this.decimal.mul(
              Math.abs(this.decimal.sub(junjia[key1].piece, junjia[key2].piece)),
              _oneLotSize,
            ),
          );
          // console.log(_priceSign, 'two', Number(two));
          let three = this.decimal.sub(_priceSign, two);
          // console.log('预计强评价：', Number(three), '10倍标记价：', _priceSign * 10, _symbol);
          return three <= 0 ? '--' : three >= _priceSign * 10 ? '--' : three;
        } else {
          if (allyk == '-') {
            return '--';
          }
          // console.log(_available, Number(allyk), totalMargin, _stopCrossPositionRate);
          // 强平价 = 标记价 - 开仓方向(多1、空-1) * (available(接口字段) + sum(所有仓位浮动盈亏) - sum(手续费) - sum(仓位保证金) * 风险率) / (张数 * 合约面值)

          let one = this.decimal.sub(
            this.decimal.add(_available, allyk), //allyk 已经减去了手续费
            this.decimal.mul(totalMargin, _stopCrossPositionRate),
          );
          // console.log('one', Number(one));
          _piece = junjia[key1] ? junjia[key1].piece : junjia[key2] ? junjia[key2].piece : 0;
          let two = this.decimal.div(
            this.decimal.mul(_dic, one),
            this.decimal.mul(_piece, _oneLotSize),
          );
          // console.log(_priceSign, 'two', Number(two));
          let three = 0;
          if (two) {
            three = this.decimal.sub(_priceSign, two);
          }
          // console.log(
          //   '预计强评价：',
          //   Number(three),
          //   '10倍标记价：',
          //   _priceSign * 10,
          //   _symbol,
          //   _piece,
          // );
          if (Number(three <= 0)) {
            return '--';
          } else {
            if (Number(three) >= _priceSign * 10) {
              return '--';
            } else {
              return three;
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
      return '--';
    }
  },
  //数量单位切换
  getAmount(amount, price, _symbol, $usdtDigits, $store) {
    let scState = $store.getters.getSheetOrCoinStore.sheetOrCoin;
    let _oneLotSize = (_symbol && _symbol.data.oneLotSize) || 1;
    let _biDigits = _symbol ? _symbol.biDigits : 1;
    switch (scState) {
      case 'sheet':
        //张
        return amount;
      case 'bi':
        //币
        return this.toFixedJQ(this.decimal.mul(amount, _oneLotSize) || 0, _biDigits);
      case 'coin':
        return this.toFixedJQ(
          this.decimal.mul(this.decimal.mul(amount, price), _oneLotSize) || 0,
          $usdtDigits,
        );
    }
  },
  getSheetOrCoin($store) {
    let _this = window.vm;
    let scState = $store.getters.getSheetOrCoinStore.sheetOrCoin;
    return scState === 'sheet'
      ? _this.$t('placeOrder.张')
      : scState === 'bi'
        ? _this.$t('placeOrder.币')
        : 'USDT';
  },
  keepTwoDecimalFull: function(num) {              
    var result = parseFloat(num);              
    if (isNaN(result)) return false;             
    result = Math.round(num * 100) / 100;              
    var s_x = result.toString(); //将数字转换为字符串
    var pos_decimal = s_x.indexOf('.'); //小数点的索引值
    
    // 当整数时，pos_decimal=-1 自动补0  
    if (pos_decimal < 0) {  
        pos_decimal = s_x.length;  
        s_x += '.';  
    }
    // 当数字的长度< 小数点索引+2时，补0  
    while (s_x.length <= pos_decimal + 2) {  
        s_x += '0';  
    }  
    return s_x;  
  },
  //Lihe.add 把科学计数法转成数字
	getFullNum : function(num){
		//处理非数字
		if(isNaN(num)){return num};
		//处理不需要转换的数
		var str = ''+num;
		if(!/e/i.test(str)){return num;};
		return Number(num).toFixed(18).replace(/\.?0+$/, "");
	},

	numFormat : function(money, digit) {
        if (!digit) {
            digit = 4;
        }
		// money = this.getFullNum(new Number(money).valueOf());
		money = this.getFullNum(money);
        if (money != null && money.toString().split(".") != null && money.toString().split(".")[1] != null) {
            var end = money.toString().split(".")[1];
            if (end.length > digit) {
                end = end.substring(0, digit);
            } else if (end.length < digit) {
                var len = end.length;
                for (var i = 0; i < digit - len; i++) {
                    end += "0";
                }
            }
            money = money.toString().split(".")[0] + "." + end;
        } else {
            if (!money) {
                money = "0";
            }
            money = money.toString() + ".";
            for (var i = 0; i < digit; i++) {
                money += "0";
            }
        }
        if (digit == 0) {
            money = money.substring(0, money.length - 1);
        }
        return money;
    },
};

export default Utils;



// WEBPACK FOOTER //
// ./src/common/commonUtils.js